import {useEffect, useState} from "react";
import {Badge} from "reactstrap";
import {getWithdrawalHistory} from "@store/actions/withdrawal";
import {useDispatch, useSelector} from "react-redux";
import alert from "@src/utility/Alert";
import AtomPageLoader from "@atoms/PageLoader";
import OrganismDatatable from "@organism/datatable";
import moment from "moment";

const WithdrawalHistory = ({stepper, id, loadSection}) => {
    const dispatch = useDispatch();
    const {
        withdrawals
    } = useSelector((state) => state.withdrawal);
    const [isFetch, setIsFetch] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if(id === loadSection) {
                try {
                    setIsFetch(false);
                    setLoading(true);
                    await dispatch(getWithdrawalHistory());
                } catch (error) {
                    alert.error(error.message);
                } finally {
                    setLoading(false);
                    setIsFetch(true);
                }
            }
        })();
    }, [loadSection]);

    const columns = [
        {
            name: 'Tanggal',
            selector: ({created_at}) => (
                moment().format("MMMM Do YYYY, h:mm:ss a")
            ),
            sortable: true,
        },
        {
            name: 'Bank',
            selector: 'bank.name',
            sortable: true,
        },
        {
            name: 'Nama Rekening',
            selector: 'account_name',
            sortable: true,
        },
        {
            name: 'Nomor Rekening',
            selector: 'account_number',
            sortable: true,
        },
        {
            name: 'Nominal',
            selector: 'amount',
            sortable: true,
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
        },
    ]
    return (
        <>
            <Badge color="primary" className={"mb-2"}>Status penarikan</Badge>
            {loading ? <AtomPageLoader/> :
            <>
                <OrganismDatatable
                    tableData={withdrawals}
                    columns={columns} />
            </>
            }
        </>
    )
}

export default WithdrawalHistory